import { render } from "./edit-company-info.vue?vue&type=template&id=0dd999cd&scoped=true"
import script from "./edit-company-info.vue?vue&type=script&lang=js"
export * from "./edit-company-info.vue?vue&type=script&lang=js"

import "./edit-company-info.vue?vue&type=style&index=0&id=0dd999cd&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd999cd"]])

export default __exports__